import React, { useState } from "react";

//UI Material
import {
  Button,
  Card,
  CircularProgress,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";

//Material Icons
import { Add, ArrowBackIos } from "@mui/icons-material";

//Local components
import DeviceRow from "../Components/connectivity-devices-page/DeviceRow";

//TESTING DEVICE
const testingDevice = {
  id: 1,
  description: "Dispositivo de pruebas",
  IMEI: "863993062298873",
  SIM: "KOLBI-8851601092321199428",
  SSID: "ELCO-X0h4o-PA",
  accessIP: "192.168.100.1",
  adminPass: "gHKba64eG88U",
  createdAt: "2024-04-22T13:00:19Z",
  createdBy: "fmatamorosa09@icloud.com",
  macAddress: "Unknown",
  brand: "LTE",
  model: "4G Dongle",
  password: "7hd399ske3",
  stations: ["station123146"],
};

export default function ConnectivityDevices() {
  // ==========>Component States<==========
  //State for devices list
  const [devicesList, setDevicesList] = useState([testingDevice]);
  //State for select page
  const [page, setPage] = useState(0);
  //State for manage rows per page
  const [rowsPerPage, setRowsPerPage] = useState(10);
  //State for devices loading data
  const [devicesLoader, setdevicesLoader] = useState(false);

  // ==========>Component Functions<==========
  //Function to manage page selection
  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  //Function to control rows per page options
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // ==========>Component<==========
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={1}
        >
          <Button
            startIcon={<ArrowBackIos />}
            color="secondary"
            sx={{ color: "white" }}
            variant="contained"
            size="small"
            onClick={() => {
              window.history.back();
            }}
          >
            Volver
          </Button>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            sx={{ color: "white" }}
            endIcon={<Add />}
            onClick={() => {
              //setOpenDrawer(true);
            }}
          >
            nuevo dispositivo
          </Button>
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Card raised>
          <Grid container>
            <Grid item xs={12} sx={{ p: 2 }}>
              <Typography variant="h6" fontWeight="bold">
                Lista de dispositivos de conectividad
              </Typography>
            </Grid>
            <Grid item xs={12} sx={{ p: 2 }}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="flex-start"
                spacing={1}
              >
                <Typography variant="h6" fontWeight="bold">
                  {devicesList.length}
                </Typography>
                <Typography variant="h7">dispositivos registrados</Typography>
              </Stack>
            </Grid>
            <Grid item xs={12}>
              <TableContainer>
                <Table aria-label="items-table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          ID
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          Descripción
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          Marca y modelo
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          Fecha de registro
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          SIM
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          Acciones
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {devicesLoader ? (
                      <TableCell align="center" colSpan={7}>
                        <CircularProgress />
                      </TableCell>
                    ) : (
                      devicesList
                        .map((device) => (
                          <DeviceRow
                            data={device}
                            key={
                              device.description +
                              device.createdAt +
                              device.IMEI
                            }
                          />
                        ))
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={devicesList.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                labelRowsPerPage="Filas"
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
}
